import { Action, Dispatch } from 'redux'
import { openCautionModalAction } from 'reducks/modal/actions'

const openCautionModal = (
  actionLabel: string,
  cancelLabel: string,
  description: string,
  onClickAction: () => void,
  title: string,
  actionType?: 'blue' | 'outlined'
) => {
  return async (dispatch: Dispatch<Action>) => {
    dispatch(openCautionModalAction(actionLabel, cancelLabel, description, onClickAction, title, actionType))
  }
}

export default openCautionModal
